<template>
  <div class="addExtraCostPage">
    <Form>
      <Row>
        <Table :dataSource="tableData" :pagination="false" rowKey="removeId" size="middle" border style="margin-bottom:16px;">
          <TableColumn title="名称" dataIndex="name" width="20%">
            <template slot-scope="text, record">
              <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="record.materialId" :disabled="record.editFlag" @change='handleChangeData(record)'>
                <Option v-for="(item, index) in consumList" :key="index" :value="item.id">{{item.material_name}} {{(item.manufacter)}}</Option>
              </Select>
            </template>
          </TableColumn>
          <TableColumn title="数量" dataIndex="sum" width="20%">
            <template slot-scope="text, record">
              <Input type="number" :min="1" v-model="record.count" @change="changeCount(record)" :disabled="record.editFlag"/>
            </template>
          </TableColumn>
          <TableColumn title="单价" dataIndex="price" width="20%">
            <template slot-scope="text, record">{{record.materialPrice}}</template>
          </TableColumn>
          <TableColumn title="金额" dataIndex="money" width="20%">
            <template slot-scope="text, record">{{record.materialAmount}}</template>
          </TableColumn>
          <TableColumn width="20%">
            <a slot="title" @click="addConsumables" v-if="!editInfo.price">新增耗材</a>
            <template slot-scope="text, record">
              <a @click="removeConsum(record)" v-if="!editInfo.price">删除</a>
            </template>
          </TableColumn>
        </Table>
      </Row>
      <Row :gutter="24">
        <Col :span="12"></Col>
        <Col :span="12">
          <FormItem required label="医疗费用">
            <Input type="number" :min="0" disabled v-model="amount" />
          </FormItem>
          <FormItem required label="实际费用">
            <Row>
              <Col :xs="{span: 17}" :md="{span: 19}" :xl="{span: 17}" >
                <Input v-model="actualCost" disabled ></Input>
              </Col>
              <Col :xs="{span: 5}" :md="{span: 3}" :xl="{span: 5}">
                <Button type="primary" class="matchButtonWrap" @click="handleChangePirce">修改</Button>
              </Col>
            </Row>
          </FormItem>
          <FormItem required label="收费渠道">
            <Select allowClear :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" :defaultValue="''" v-model="costChannel" placeholder="请选择付费渠道">
              <Option v-for="val in costChannelList" :key="val.id" :value="val.name">{{val.name}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div class="footer">
      <div>
        <Button size="large" @click="removeModal">取消</Button>
        <Button type="primary" size="large" @click="savePrice" :loading="saveLoading">保存</Button>
      </div>
    </div>
    <!-- 修改实际费用 -->
    <Modal v-model="showChangePrice"  v-if="showChangePrice" title="修改实际费用" :footer="null">
      <changePrice @closeChangePrice="closeChangePrice" :userPrice="actualCost" @handleSureChange="handleSureChange" changeType="extraCost" :checkOrderId="editInfo.orderCheckId"></changePrice>
    </Modal>
  </div>
</template>

<script>
import { Row, Col, Table, Form, Select, Input, Button, Modal } from 'ant-design-vue'
import { getConsumListByCenter, addOtherPrice, removePriceConsum, editOtherPrice } from '../../api/historyCheck'
import { mapState } from 'vuex'
import changePrice from '../../components/changePrice'
import { makePayCode } from '../../api/onlineCheckin'
export default {
  props: {
    checkOrderId: {
      type: Number,
      default: 0
    },
    editInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Row,
    Col,
    Table,
    Form,
    FormItem: Form.Item,
    Select,
    Option: Select.Option,
    Input,
    TableColumn: Table.Column,
    Button,
    Modal,
    changePrice
  },
  data () {
    return {
      tableData: [],
      costChannel: undefined,
      costChannelList: [
        { id: '线下-HIS', name: '线下-HIS' },
        { id: '线上-微信', name: '线上-微信' },
        { id: '线上-支付宝', name: '线上-支付宝' },
        { id: '线下-POS机银行卡', name: '线下-POS机银行卡' },
        { id: '线下-POS机微信', name: '线下-POS机微信' },
        { id: '线下-POS机支付宝', name: '线下-POS机支付宝' },
        { id: '线下-现金', name: '线下-现金' },
      ],
      amount: 0, // 医疗费用
      actualCost: '',
      consumList: [],
      editFlag: false,
      saveLoading: false,
      showChangePrice: false,
      changeReason: ''
    }
  },
  computed: {
    ...mapState({
      currentCenterId: state => state.app.currentCenterId,
      payType: state => state.app.payType
    })
  },
  async mounted () {
    this.handleEditInfo()
    if (this.payType && this.editInfo.addFlag) this.costChannel = this.payType
    await this.getConsumList()
    if (this.editInfo.addFlag) {
      this.addConsumables()
    }
    if (this.editInfo.editInfo) {
      this.costChannel = this.editInfo.chargeChannel
    }
  },
  methods: {
    // 获取影像中心的耗材列表
    async getConsumList() {
      let data = await getConsumListByCenter({ medicalImageCenterId: this.currentCenterId})
      if (data) this.consumList = data
    },
    // 处理编辑数据
    handleEditInfo () {
      if (this.editInfo.price) this.actualCost = this.editInfo.price
      if (this.editInfo.priceTotal) this.amount = this.editInfo.priceTotal
      if (this.editInfo.chargeChannel) this.costChannel = this.editInfo.chargeChannel
      if (this.editInfo.orderCheckMaterialList) {
        let arr = []
        for (let i = 0; i < this.editInfo.orderCheckMaterialList.length; i++) {
          let item = this.editInfo.orderCheckMaterialList[i]
          let obj = {}
          obj.material_name = item.material_name,
          obj.count = item.cost_count,
          obj.materialAmount = item.price,
          obj.materialId = item.hospital_medical_image_center_material_id,
          obj.materialPrice = item.total_cost
          obj.removeId = item.id
          obj.id = item.id
          obj.editFlag = true
          arr.push(obj)
        }
        this.tableData = arr
      }
    },
    // 新增耗材
    addConsumables () {
      if (this.consumList && this.consumList.length !== 0) {
        this.tableData.push({
          material_name: this.consumList[0].material_name,
          count: 1,
          materialAmount: this.consumList[0].price,
          materialId: this.consumList[0].id,
          materialPrice: this.consumList[0].price,
          editFlag: false,
          id: this.consumList[0].id,
          removeId: (new Date()).getTime(),
          addFlag: 'add'
        })
        this.amount = 0
        this.actualCost = 0
        for (let i = 0; i < this.tableData.length; i++) {
          this.amount += this.tableData[i].materialAmount
          this.actualCost += this.tableData[i].materialAmount
        }
      }
    },
    // 更改耗材
    handleChangeData (record) {
      for (let i = 0; i < this.consumList.length; i++) {
        let item = this.consumList[i]
        if (record.materialId === item.id) {
          record.count = 1
          record.materialAmount = item.price,
          record.materialPrice = item.price
          record.material_name = item.material_name,
          record.id = item.id
        }
      }
      this.computedMaterial(this.tableData)
    },
    // 改变数量后的价格变化
    changeCount (record) {
      if (record && record.count) {
        record.materialAmount = record.materialPrice * record.count
      }
      this.computedMaterial(this.tableData)
    },
    // 计算耗材价格
    computedMaterial (arr) {
      this.amount = 0
      this.actualCost = 0
      if (!arr) return ''
      for(let i = 0, len = arr.length; i < len; i++) {
        this.amount += arr[i].count * arr[i].materialPrice
        this.actualCost += arr[i].count * arr[i].materialPrice
      }
    },
    // 删除耗材
    async removeConsum (record) {
      if (record.addFlag) {
        this.tableData.splice(this.tableData.indexOf(record), 1)
      } else {
        await removePriceConsum({ id: record.id, orderCheckId: this.editInfo.orderCheckId })
        this.tableData.splice(this.tableData.indexOf(record), 1)
      }
      this.amount = this.amount - record.materialAmount
      this.actualCost = this.actualCost - record.materialAmount
      if (this.tableData.length === 0) {
        this.amount = 0
        this.costChannel = undefined
        this.actualCost = 0
      }
    },
    // 点击修改实际费用
    handleChangePirce () {
      this.showChangePrice = true
    },
    handleSureChange (val) {
      this.showChangePrice = false
      this.actualCost = val.changePrice
      this.changeReason = val.changeReason
    },
    closeChangePrice () {
      this.showChangePrice = false
    },
    // 取消
    removeModal () {
      this.$emit('closeAddPrice')
    },
    // 保存
    async savePrice () {
      if (this.editInfo.price !== '' && this.tableData.length === 0) {
        return this.$emit('closeAddPrice')
      }
      if (this.tableData.length === 0) return Modal.error({ title: '请添加耗材' })
      if (!this.actualCost) return Modal.error({ title: '请填写实际费用' })
      if (!this.costChannel) return Modal.error({ title: '请选择收费渠道' })
      let params = {
        actualCost: this.actualCost,
        chargeChannel: this.costChannel
      }
      if (this.changeReason) params.priceRemark = this.changeReason
      if (!this.editInfo.addFlag) {
        params.orderCheckId = this.editInfo.orderCheckId
      } else {
        params.orderCheckId = this.checkOrderId
      }
      let arr = []
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i]
        let obj = {}
        obj.costCount = item.count
        obj.materialId = item.materialId
        obj.materialName = item.material_name,
        obj.totalCost = item.materialPrice
        if (item.id) obj.orderCheckMaterialId = item.id
        arr.push(obj)
      }
      params.orderCheckMaterialDtoList = arr
      if (this.saveLoading) return false
      this.saveLoading = true
      if (!this.editInfo.addFlag) {
        let data = await editOtherPrice(params)
        if (data) {
          await makePayCode({ checkOrderId: data })
          this.saveLoading = false
          this.$emit('saveSuccsee')
        }
      } else {
        let data = await addOtherPrice(params)
        if (data) {
          await makePayCode({ checkOrderId: data })
          this.saveLoading = false
          this.$emit('saveSuccsee')
        }
      }
    }
  }
}
</script>

<style lang="less">
@import '../../style/index.less';
  .addExtraCostPage{
  .footer{
    .modalFooter();
  }
  .ant-row .ant-form-item{
    display: flex;
    margin-bottom: 16px;
    .ant-table-wrapper {
      margin-bottom: 16px;
    }
    .ant-form-item-label{
      padding-right: 10%;
    }
    .ant-form-item-control-wrapper{
      width: 100%;
    }
  }
}
</style>